import Loadable from "react-loadable";
import LoadingComponent from "../../commons/loader";

export default [
  {
    path: "/dashboard/brands",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/index"),
      loading: LoadingComponent
    })
  },
  {
    path: "/dashboard/brands/:brand/projects",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/projects/list"),
      loading: LoadingComponent
    })
  },
  {
    path: "/dashboard/brands/:brand/projects/:projectId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/projects/details"),
      loading: LoadingComponent
    })
  },
  {
    path: "/dashboard/brands/:brand/projects/:projectId/locations",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/projects/details/pages/location"),
      loading: LoadingComponent
    })
  },
  {
    path: "/dashboard/brands/:brand/projects/:projectId/building-details",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/projects/details/pages/building-details"),
      loading: LoadingComponent
    })
  },
  {
    path: "/dashboard/brands/:brand/projects/:projectId/amenities",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/projects/details/pages/amenities"),
      loading: LoadingComponent
    })
  },
  {
    path: "/dashboard/brands/:brand/projects/:projectId/floor-plans/:floorId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/projects/details/pages/floor-plan"),
      loading: LoadingComponent
    })
  },
  {
    path: "/dashboard/brands/:brand/projects/:projectId/unit-details/:unitId",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/projects/details/pages/unit-details"),
      loading: LoadingComponent
    })
  },
  {
    path: "/dashboard/brands/:brand/projects/:projectId/availability",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/projects/availability/index"),
      loading: LoadingComponent
    })
  },
  {
    path:
      "/dashboard/brands/:brand/projects/:projectId/buildings/:buildingCode/availability",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/projects/availability/charts"),
      loading: LoadingComponent
    })
  },
  {
    path: "/dashboard/brands/:brand/projects/:id/site",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/projects/site"),
      loading: LoadingComponent
    })
  },
  {
    path: "/dashboard/brands/:brand/projects/:id/unit",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/projects/unit"),
      loading: LoadingComponent
    })
  }
];
